import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="B">
        <path 
          fill="currentColor"
          transform="translate(0.5, 6)"
        d="M 44.5,27.5 C 53.3494,27.1736 62.0161,27.507 70.5,28.5C 68.329,30.5002 65.9957,32.3335 63.5,34C 57.1406,34.1694 50.8072,34.6694 44.5,35.5C 43.3719,40.474 42.3719,45.474 41.5,50.5C 40.596,51.209 40.2627,52.209 40.5,53.5C 46.8333,53.5 53.1667,53.5 59.5,53.5C 61.334,55.5054 63.0007,57.6721 64.5,60C 55.1667,60.6667 45.8333,60.6667 36.5,60C 35,59.1667 33.8333,58 33,56.5C 33.4201,48.7262 34.7535,41.0595 37,33.5C 38.6617,30.4231 41.1617,28.4231 44.5,27.5 Z"/>
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="bevel"
        strokeLinejoin="bevel"
        d="M 132.835938 193.101562 L 67.164062 193.101562 L 16.859375 150.898438 L 5.460938 86.226562 L 38.289062 29.351562 L 100 6.898438 L 161.710938 29.351562 L 194.539062 86.226562 L 183.140625 150.898438 Z M 132.835938 193.101562 " transform="matrix(0.5,0,0,0.5,0,0)"/>
    </g>
  </svg>
);

export default IconLoader;
